export const getUpdatedSelectedRows = (selectedRowsIds: number[], updatedRowsIds: number[]): number[] => {
  let newSelectedRowsIds = [...selectedRowsIds];

  if (updatedRowsIds.length === 1) {
    const selectedRowId = updatedRowsIds[0];
    const selectedRowsIdsFromStateHasCurrentRowId = checkRowIdEntry(newSelectedRowsIds, updatedRowsIds);

    if (selectedRowsIdsFromStateHasCurrentRowId) {
      newSelectedRowsIds = newSelectedRowsIds.filter((rowId) => rowId !== selectedRowId);
    } else {
      newSelectedRowsIds.push(selectedRowId);
    }
  } else {
    newSelectedRowsIds = getSelectedRows(updatedRowsIds, newSelectedRowsIds);
  }

  return newSelectedRowsIds;
};

const checkRowIdEntry = (selectedRowIds: number[], selectedRowId: number[]) =>
  selectedRowIds.includes(selectedRowId[0]);

const getSelectedRows = (selectedRowIds: number[], selectedRowsIdsFromState: number[]) => {
  return selectedRowIds.length !== selectedRowsIdsFromState.length ? [...selectedRowIds] : [];
};
